/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-01-16T10:23:54-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-18T14:50:28-07:00
*/



import React, { Component, PropTypes } from 'react';
import validator from 'validator';
import UserConfig from '../../../config/User';
import InputGroup from '../../blocks/InputGroup';
import TextInput from '../../common/TextInput';
import Headline from '../../common/Headline';
import Button from '../../blocks/Button';
import Panel from '../../common/Panel';
import { Link } from 'react-router';

import HeaderOut from '../../blocks/HeaderOut';
import Container from '../../blocks/Container';
import Checkbox from '../../common/Checkbox';
import { css, StyleSheet } from 'aphrodite/no-important';
import { box, spacing, link, color } from '../../../style';

const style = StyleSheet.create({
  page: {
    ...spacing.PADDING_TOP_LG,
    maxWidth: '460px',
    margin: '0 auto'
  },

  message: {
    textAlign: 'center'
  },

  textLink: {
    cursor: 'pointer',
    color: color.BRAND_1_DARK
  },
  terms: {
    marginTop: 8,
    marginBottom: 8
  }
});

class JoinS1 extends Component {

  constructor(props) {
    // console.log("JOINS1 props");
    // console.log(props);
    super(props);

    let { username, email, errors, ref, radio_code, referral } = this.props.location.query;
    this.state = {
      username: '' || username,
      email: '' || email,
      pass: '',
      passConfirm: '',
      termsChecked: true,
      promoCode: '',
      passwordsMatch: true,
      ref: '' || ref,
      radio_code: '' || radio_code,
      referral: '' || referral,
      show_promo: false
    }

    // store errors if present in GET.
    console.log("errors", errors);
    if(errors) {
      console.log("errors present");
      this.props.storeErrors(errors);
    }


    this.usernameChangeHandler = this.usernameChangeHandler.bind(this);
    this.emailChangeHandler = this.emailChangeHandler.bind(this);
    this.passChangeHandler = this.passChangeHandler.bind(this);
    this.passConfirmChangeHandler = this.passConfirmChangeHandler.bind(this);
    this.termsChangeHandler = this.termsChangeHandler.bind(this);
    this.promoCodeChangeHandler = this.promoCodeChangeHandler.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.showPromoClick = this.showPromoClick.bind(this);
  }


  usernameChangeHandler(e) {
    let username = e.target.value;
    this.setState({username});
  }

  emailChangeHandler(e) {
    let email = e.target.value;
    this.setState({email});
  }

  passChangeHandler(e) {
    let pass = e.target.value;
    this.setState({pass});
    // confirm passwords match
    this.setState({passwordsMatch: Boolean(this.state.passConfirm === pass)})
  }

  passConfirmChangeHandler(e) {
    let passConfirm = e.target.value;
    this.setState({passConfirm});
    // confirm passwords match
    this.setState({passwordsMatch: Boolean(this.state.pass === passConfirm)})
  }

  termsChangeHandler(e) {
    this.setState({termsChecked: !this.state.termsChecked});
  }

  promoCodeChangeHandler(e) {
    this.setState({promoCode: e.target.value});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.registerUser(this.state);
  }

  showPromoClick(e) {
    e.preventDefault();
    this.setState({show_promo: !this.state.show_promo});
  }

  render() {
    var allowSubmit = Boolean(this.state.username && this.state.email && this.state.pass
      && this.state.passConfirm && this.state.termsChecked && this.state.passwordsMatch);

    
    return (
      <div className={css(style.page)}>

      <Container>
        <Headline spaceAfter>
          Create a free account
        </Headline>
      </Container>
      <Container padding='large'>
        <Panel padding="large">


            <form id="join" className="form-horizontal" onSubmit={this.handleSubmit}>
              {/* Username */}
              <InputGroup vertical inputLabel="Username" errors={this.props.errors.username}>
                <TextInput onChange={this.usernameChangeHandler} value={this.state.username} error={this.props.errors.username} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" type="text" name="username" id="username" />
              </InputGroup>

              {/* Email */}
              <InputGroup vertical inputLabel="Email Address" errors={this.props.errors.email}>
                <TextInput onChange={this.emailChangeHandler} value={this.state.email} error={this.props.errors.email} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" className="submission-form InputValidate" name="email" id="email" />
              </InputGroup>

              {/* Password */}
              <InputGroup vertical inputLabel="Password" errors={this.props.errors.password}>
                <TextInput onChange={this.passChangeHandler} type="password" value={this.state.pass} error={this.props.errors.password} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" type="password" name="password" className="submission-form" id="password" />
              </InputGroup>

              {/* Confirm Password */}
              <InputGroup vertical inputLabel="Confirm your Password" errors={this.props.errors.password_confirm}>
                <TextInput onChange={this.passConfirmChangeHandler} value={this.state.passConfirm} error={this.props.errors.password_confirm} autoComplete="off" autoCorrect="off" autoCapitalize="off" spellCheck="false" type="password" name="password_confirm" className="submission-form" id="password_confirm" />
                {!this.state.passwordsMatch ? 'Passwords do not match' : ''}
              </InputGroup>

              {/* Terms */}
              <div className={css(style.terms)}>
                By Creating an account, you agree to our <a href="https://www.misstravel.com/privacy" target="_blank" className={css(style.textLink)}>Terms and Privacy</a>
              </div>
              <div className="u-textCenter">
                { allowSubmit ?
                  <Button variant="primary" fit type="submit">Continue</Button>
                  :
                  <Button variant="simple" fit disabled type="submit">Signup</Button>
                }
              </div>
            </form>
        </Panel>
    <div className={css(style.message)}>
      Please <Link to="/login" className={css(link.Link)}>sign in</Link> if you already have an account
    </div>
  </Container>
</div>

    );
  }
}


export default JoinS1;



// WEBPACK FOOTER //
// ./src/components/pages/Join/JoinS1.jsx